import { mockable } from '@datadog/browser-core';
import { reportScriptLoadingError } from '../domain/scriptLoadingError';
export async function lazyLoadRecorder() {
    try {
        return await mockable(importRecorder)();
    }
    catch (error) {
        reportScriptLoadingError({
            error,
            source: 'Recorder',
            scriptType: 'module',
        });
    }
}
export async function importRecorder() {
    const module = await import(/* webpackChunkName: "recorder" */ './startRecording');
    return module.startRecording;
}
//# sourceMappingURL=lazyLoadRecorder.js.map